import React from "react";
import ct from "class-types.macro";
import Tippy from "@tippyjs/react/headless";
import { User } from "~/common/Store/models/User";
import { PricingProduct } from "~/ProductDetails/Pricing/PricingProduct";
import shouldDisplayQuantityDiscountRibbon from "./shouldDisplayQuantityDiscountRibbon";
import Arrow from "~/common/PopupArrow";
import shouldDisplayMapStyle from "./shouldDisplayMapStyle";
import("./RibbonsStyling.scss");
interface Props {
  product: PricingProduct;
  user: User;
  showGoogleView?: boolean;
}
const Ribbons = ({
  product,
  user,
  showGoogleView = false
}: Props) => {
  const {
    isNewProduct,
    mixAndMatchUrl,
    purchasingGroupUrl,
    isWebstaurantPlusEligible,
    hasFreeShipping
  } = product;
  const displayQuantityDiscounts = shouldDisplayQuantityDiscountRibbon({
    ...product
  }, user);
  const displayMapStyle = shouldDisplayMapStyle(product, user);
  return <div className="ribbon-list -ml-6 xs:-ml-5 lt:-ml-7 " data-component="RibbonList" data-sentry-component="Ribbons" data-sentry-source-file="Ribbons.tsx">
      {isNewProduct && <div className="ribbon ribbon--new">
          <span className="ribbon__text">New</span>
        </div>}
      {!displayMapStyle && mixAndMatchUrl && <a href={mixAndMatchUrl} className="ribbon ribbon--mix">
          <span className="ribbon__text">
            {"Mix & Match Discounts "}
            <i className="ribbon__icon icon-right-open" />
          </span>
        </a>}
      {purchasingGroupUrl && <a href={purchasingGroupUrl} className="ribbon ribbon--mix">
          <span className="ribbon__text">
            {"Mix & Match "}
            <i className="ribbon__icon icon-right-open" />
          </span>
        </a>}
      {displayQuantityDiscounts && showGoogleView && <a href={product.link} className="ribbon ribbon--quantity">
          <span className="ribbon__text">
            View Quantity Discounts&nbsp;
            <i className="ribbon__icon icon-right-open" />
          </span>
        </a>}
      {displayQuantityDiscounts && !showGoogleView && <div className="ribbon ribbon--quantity">
          <span className="ribbon__text">Quantity Discounts</span>
        </div>}
      {hasFreeShipping && !(user.hasWebPlus && isWebstaurantPlusEligible) && <Tippy placement="top" interactive trigger="mouseenter" render={attrs => <div className="tippy-with-arrow-black">
              <div className="tippy-box">
                <div className="tippy-content">
                  <p className={ct("text-sm-1/2", "mb-0")}>
                    Contiguous U.S. Only
                  </p>
                  {attrs["data-placement"] && <div className="tippy-arrow">
                      <Arrow placement={attrs["data-placement"]} />
                    </div>}
                </div>
              </div>
            </div>}>
          <button type="button" className={`ribbon ribbon--shipping ${product.isWebstaurantPlusEligible ? "ribbon--shipping-show" : ""}`} data-testid="freeShippingRibbon">
            <span className="ribbon__text">
              Free Shipping <i className="ribbon__icon icon-question" />
            </span>
          </button>
        </Tippy>}
    </div>;
};
export default Ribbons;